import HomeCardTitle from "../HomeCardTitle";
import styles from "./style.module.scss";
const HomeCard = ({
  title = "",
  children = null,
  renderExtra = () => {},
  containerStyle = "",
  backCardStyle = "",
  frontCardStyle = "",
  hideTitle = false,
}) => {
  return (
    <div className={`${styles.card} ${styles.back} ${backCardStyle}`}>
      <div className={`${styles.card} ${styles.front} ${frontCardStyle}`}>
        {hideTitle === false ? <HomeCardTitle title={title} renderExtra={renderExtra} /> : null}
        <div className={`${styles.bodyContainer} ${containerStyle}`}>{children}</div>
      </div>
    </div>
  );
};

export default HomeCard;
